import { useContext } from 'react';
import { Stack } from '@mantine/core';
import { i18n } from '@lingui/core';
import validator from 'validator';
import { BankAccountContext } from '../../Service/Context/BankAccountContext';
import PanePaper from '../PanePaper';
import BookitupTextInput from '../../Atoms/inputs/BookitupTextInput';

const removeWhitespace = (value: string) => value.replace(/\s/g, '');

const BankAccountSettings = () => {
  const { bankAccount, saveBankAccountChange } = useContext<any>(BankAccountContext);
  if (!bankAccount) {
    return null;
  }
  const { nameOfBank, iban, bic, nameOfOwner } = bankAccount;

  return (
    <PanePaper title="common.settings.bankaccount">
      <Stack spacing="xs">
        <BookitupTextInput
          label={i18n._('applicationuser.bankaccount.nameOfOwner')}
          defaultValue={nameOfOwner}
          onBlurSave={(val) => saveBankAccountChange({ nameOfOwner: val })}
        />
        <BookitupTextInput
          label={i18n._('applicationuser.bankaccount.name')}
          defaultValue={nameOfBank}
          onBlurSave={(val) => saveBankAccountChange({ nameOfBank: val })}
        />
        <BookitupTextInput
          label={i18n._('applicationuser.bankaccount.iban')}
          defaultValue={iban}
          onBlurSave={(val) => saveBankAccountChange({ iban: removeWhitespace(val) })}
          validate={(val) => validator.isIBAN(removeWhitespace(val))}
          errorMessage={i18n._('error.input-field.invalid-iban')}
        />
        <BookitupTextInput
          label={i18n._('applicationuser.bankaccount.bic')}
          defaultValue={bic}
          onBlurSave={(val) => saveBankAccountChange({ bic: removeWhitespace(val) })}
          validate={(val) => validator.isBIC(removeWhitespace(val))}
          errorMessage={i18n._('error.input-field.invalid-bic')}
        />
      </Stack>
    </PanePaper>
  );
};

export default BankAccountSettings;
